import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

const pages = [
  { name: "About Me", id: "about" },
  { name: "My Work", id: "work" },
  { name: "Contact", id: "contact" },
];

// links with the same style and with hover effect
const navLinkStyle = {
  color: "#333",
  textDecoration: "none",
  fontFamily: "Playfair Display",
  position: "relative",

  "&::after": {
    content: '""',
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "0%",
    height: "2px",
    backgroundColor: "#666",
    transition: "width 0.3s ease",
  },

  "&:hover::after": {
    width: "100%",
  },
};

function ResponsiveAppBar() {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (state) => () => {
    setOpen(state);
  };

  return (
    <AppBar position="fixed" sx={{ backgroundColor: "#F8F9FA" }}>
      <Container maxWidth={false} disableGutters>
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>

          {/* HOME */}
          <Typography
            component="a"
            href="#home"
            sx={{
              ...navLinkStyle,
              fontWeight: 700,
              whiteSpace: "nowrap",
            }}
          >
            Home
          </Typography>

          {/* DESKTOP MENU */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              gap: 3,
            }}
          >
            {pages.map((page) => (
              <Typography
                key={page.name}
                component="a"
                href={`#${page.id}`}
                sx={navLinkStyle}
              >
                {page.name}
              </Typography>
            ))}
          </Box>

          {/* MOBILE HAMBURGER */}
          <IconButton
            onClick={toggleDrawer(true)}
            sx={{
              display: { xs: "flex", md: "none" },
              color: "#333",
            }}
          >
            <MenuIcon />
          </IconButton>

          {/* DRAWER */}
          <Drawer
            anchor="right"
            open={open}
            onClose={toggleDrawer(false)}
          >
            <Box sx={{ width: 250, p: 2 }}>
              <List>
                {pages.map((page) => (
                  <ListItem
                    key={page.name}
                    button
                    component="a"
                    href={`#${page.id}`}
                    onClick={toggleDrawer(false)}
                    sx={{
                      color: "#333",
                      textDecoration: "none",
                      "&:focus": { outline: "none" },
                      "&:active": { backgroundColor: "transparent" },
                    }}
                  >
                    <ListItemText primary={page.name} />
                  </ListItem>
                ))}
              </List>
            </Box>
          </Drawer>

        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default ResponsiveAppBar;